/** A new copy replaces the previous kind of canvas selection. */
export const FRAME_CLIP_KEY = 'doop:frame-clipboard'
export const ELEMENT_CLIP_KEY = 'doop:element-clipboard'
/** the CSS the copied layers rely on, with the frame it came from */
export const ELEMENT_CLIP_STYLE_KEY = 'doop:element-clipboard-styles'
